<template>
  <v-container class="preference-container" fluid>
    <v-row class="ma-0">
      <v-col :cols="menuList[0].length" v-for="(menu, idx) in menuList" :key="idx">
        <v-card class="mx-2">
          <v-list dense class="d-inline">
            <v-subheader class="grey darken-2 dialog-index-head" dark>
              <v-icon left small>{{ menu.icon }}</v-icon>
              <h2>{{ $t(menu.messageCode) }}</h2>
            </v-subheader>
            <v-list-item-group color="primary" class="dialog-index-list">
              <v-list-item v-for="(sub, idx) in menu.children" :key="idx" @click.prevent="setComponent($t(sub.messageCode), sub.path)" class="pl-1">
                <v-list-item-icon class="mr-0 mb-1">
                  <v-icon v-text="'mdi-circle-small'"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="dialog-index-menu">{{ $t(sub.messageCode) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    setComponent: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapState('common/menu', ['preference', 'allowedMenuIds']),
    /**
     * BEGIN::Modified.by.KWShin.2026.07.20.
     * 접근이 허용된 메뉴ID 목록에 없는 메뉴는 목록에서 제거한다.
     * 접근허용메뉴ID 목록이 아예 없으면 전체 메뉴를 모두 노출한다.
     */
    menuList() {
      if (this.allowedMenuIds.length > 0) {
        const idSet = new Set(this.allowedMenuIds);
        const allowedMenuList = this.findAllowedMenuOnly(this.preference, idSet);
        return allowedMenuList[0].children;
      } else {
        return this.preference[0].children;
      }
    },
  },
  methods: {
    /**
     * Added.by.KWShin.2026.07.20.
     * 트리구조로 된 메뉴 목록에서
     * idSet에 들어 있는 ID를 가진 메뉴 이외에는 제거.
     * 메뉴 목록이 children 속성을 가진 트리구조이므로 재귀적 호출을 사용.
     * /views/common/gnb/GnbNeo.vue에 동일한 로직이 있으므로 수정시에는 같이 수정할 것.
     */
    findAllowedMenuOnly(nodes, idSet) {
      if (!nodes || nodes.length === 0) return [];
      return nodes
        .map(node => {
          // 기존 객체가 오염되지 않도록 얕은 복사 수행
          const copiedNode = { ...node };
          // 자식 메뉴가 있다면 자식 메뉴들 먼저 재귀적으로 필터링을 진행 (하향 탐색)
          if (copiedNode.children && copiedNode.children.length > 0) {
            copiedNode.children = this.findAllowedMenuOnly(copiedNode.children, idSet);
          }
          return copiedNode;
        })
        .filter(node => {
          // 내가 허용된 ID(idSet에 존재)이거나,
          // 혹은 내 자식들(children) 중 살아남은 노드가 하나라도 있다면 이 노드를 유지.
          const isMyIdAllowed = idSet.has(node.id);
          const hasActiveChildren = node.children && node.children.length > 0;

          return isMyIdAllowed || hasActiveChildren;
        });
    },
    // FINISH::Added.by.KWShin.2026.07.20.
  },
};
</script>

<style>
.preference-container {
  width: 800px;
}
.preference-menu .v-subheader {
  font-size: 12px;
}
.preference-menu .v-list-item__title {
  font-size: 11px !important;
}
</style>
